import { Component, OnInit } from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcTab, IExcTab} from 'exc-tab';
import {ExcListConfig} from 'exc-controls';
import {ExcProgbarData} from '../../app-exc-progbar/app-exc-progbar.component';
import {ExcIndicatorData} from '../../app-exc-indicator/app-exc-indicator.component';
import {ExcRestService} from 'exc-rest';
import {ExcSigninService} from 'exc-signin';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {DealerActionService} from '../../dealer-action-service.service';
import {AuditActionService} from '../../audit-action-service.service';
import {AuditDetailsComponent} from '../../audit-details/audit-details.component';
import {ModalDealerEditComponent} from '../../modals/modal-dealer-edit/modal-dealer-edit.component';
import {ModalNewLocationComponent} from '../../modals/modal-new-location/modal-new-location.component';
import {GeofenceComponent} from '../../geofence/geofence.component';
import {ProviderAuditDetailsComponent} from '../provider-audit-details/provider-audit-details.component';
import {ModalEditDealerComponent} from '../../modals/modal-edit-dealer/modal-edit-dealer.component';

@Component({
  selector: 'app-provider-dealer-details',
  templateUrl: './provider-dealer-details.component.html',
  styles: []
})
export class ProviderDealerDetailsComponent extends ExcTranslation implements OnInit, IExcTab {

  Data: any;
  dealer = {Header: {}, Audits: [], Charts: null, RecentAudits: [], Hierarchy: [],  Defaults: {}, CurrentStock: [], Locations: []};
  tabinstance: any;
  auditlistconfig: ExcListConfig = new ExcListConfig();
  hierarchyListconfig: ExcListConfig = new ExcListConfig();
  currentStockListconfig: ExcListConfig = new ExcListConfig();
  progbarBalanceParts: ExcProgbarData[] = [];
  progbarCurrentBalance: ExcProgbarData[] = [];
  indicatorData: ExcIndicatorData[] = [];
  totalClaims = 0;
  level = 1;
  searchValue: string = null;
  searchValueLocations: string = null;
  stockSearchValue: string = null;
  selectedStock: [] = [];
  locationsListconfig: ExcListConfig = new ExcListConfig();
  isLoading = true;
  constructor(private excRest: ExcRestService, private excSec: ExcSigninService, private excDss: DefaultSettingsService, private das: DealerActionService, private aas: AuditActionService) {
    super();
    const _self = this;
    _self.auditlistconfig.selectionMode = 'none';
    _self.auditlistconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.auditlistconfig.OnSearch = function (searchValue, event?) {
      _self.searchValue = searchValue || '';
      _self.reloadAudits();
    };
    _self.auditlistconfig.OnPageChanged = (pageNo, event1) => {
      _self.auditlistconfig.paging.pagingPage = pageNo;
      _self.reloadAudits();
    };
    _self.auditlistconfig.OnRefresh = () => {
      _self.reloadAudits();
    };
    _self.auditlistconfig.OnDetailLink = (item) => {
      new ExcTab(_self.dealer.Header['DealerName'] + ' - ' + item.AuditID, ProviderAuditDetailsComponent, item, item.AuditID, {
        Unique: true, ReloadParent: function () {
          // _self.initialLoad();
          _self.reloadAudits();
        }
      }, true).Open();
    };
    if (excSec.isFeatured('CLI_ADT_R') || excSec.isFeatured('PRV_ADT_R')) {
      _self.auditlistconfig.OnDownload = () => {
        _self.exportAuditList();
      };
    }
    if (_self.excSec.isFeatured('PRV_ADT_CU')) {
      _self.auditlistconfig.OnAdd = () => {
        _self.aas.ProviderCreate(_self.dealer.Header).subscribe(ret => {
          _self.reloadAudits();
        });

      };
    }
    _self.currentStockListconfig.selectionMode = 'multi';
    _self.currentStockListconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.currentStockListconfig.OnSearch = function (searchValue, event?) {
      _self.stockSearchValue = searchValue || '';
      _self.loadStock();
    };
    _self.currentStockListconfig.OnPageChanged = (pageNo, event1) => {
      _self.currentStockListconfig.paging.pagingPage = pageNo;
      _self.loadStock();
    };
    _self.currentStockListconfig.OnRefresh = () => {
      _self.loadStock();
    };
    _self.currentStockListconfig.OnSelectionChanged = (selecteditems, event) => {
      _self.selectedStock = selecteditems;
    };

    _self.hierarchyListconfig.selectionMode = 'none';
    _self.hierarchyListconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.hierarchyListconfig.OnSearch = function (searchValue, event?) {
      _self.searchValue = searchValue || '';
      _self.reloadHierarchy();
    };
    _self.hierarchyListconfig.OnPageChanged = (pageNo, event1) => {
      _self.hierarchyListconfig.paging.pagingPage = pageNo;
      _self.reloadHierarchy();
    };
    _self.hierarchyListconfig.OnRefresh = () => {
      _self.reloadHierarchy();
    };
    _self.hierarchyListconfig.OnDetailLink = (item, event?) => {
      new ExcTab(item.DealerName, ProviderDealerDetailsComponent, item, item.DealerID, {
        Unique: true, ReloadParent: function () {
          // _self.initialLoad();
        }
      }, true).Open();
    };
    if (_self.excSec.isFeatured('PRV_DLR_CU')) {
      _self.locationsListconfig.OnAdd = () => {
        _self.openLocationDialog(_self.dealer.Header, null );
      };
      _self.locationsListconfig.OnDelete = (selectedItems)  => {
        _self.deleteLocations(selectedItems);
      };
    }
    _self.locationsListconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.locationsListconfig.OnSearch = function (searchValue, event?) {
      _self.searchValueLocations = searchValue || '';
      _self.reloadLocations();
    };
    _self.locationsListconfig.OnPageChanged = (pageNo, event1) => {
      _self.locationsListconfig.paging.pagingPage = pageNo;
      _self.reloadLocations();
    };
    _self.locationsListconfig.OnRefresh = () => {
      _self.reloadLocations();
    };
    _self.locationsListconfig.OnSearch = function (searchValue, event?) {
      _self.searchValueLocations = searchValue || '';
      _self.reloadLocations();
    };
  }

  ngOnInit() {
    this.initialLoad();

  }

  /* getHierarchyAttractorClass(h) {
    const x = [];
    if (h['Orientation'] === 'TOP') {
      x.push('fa-arrow-down ch-danger');
    } else if (h['Orientation'] === 'SUB') {
      x.push('fa-arrow-up ch-success');
    }
    return x;
  }
  getHierarchyAttractorTip(h) {
    if (h['Orientation'] === 'TOP') {
      return this.getRessource('OrientationTOP', {DealerName: this.dealer.Header['DealerName']});
    } else if (h['Orientation'] === 'SUB') {
      return this.getRessource('OrientationSUB', {DealerName: this.dealer.Header['DealerName']});
    }
    return null;
  } */
  editDealer() {
    const _self = this;
    if (!_self.excSec.isFeatured('PRV_DLR_CU')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }
    ExcCoreModule.showModal(ModalEditDealerComponent, null, 'l',
      { data:  _self.dealer.Header, clients: []}, false, null).subscribe(ret => {
      if (ret.proceed === true) {
          if ( _self.dealer.Header !== null ) {
            ret.dealer['DealerUPT'] = _self.dealer.Header['DealerUPT'];
            const url = _self.excRest.computeUrl('Provider_DealerU', {DealerID:  _self.dealer.Header['DealerID']});
            _self.excRest.put(url,  ret.dealer, {}, false).subscribe(obj => {
              if (obj) {
                _self.dealer.Header = obj.data.Header;
                ExcCoreModule.call('P_Dealer_Reload');
              }
            });
        }
      }
    });
  }
  handleEditComment() {
    const _self = this;
    this.das.Comment(this.dealer.Header['DealerID'], this.dealer.Header['DealerUPT'], this.dealer.Header['DealerComment'])
      .subscribe(ret => {
        Object.assign(_self.dealer.Header, ret.Data);
      });
  }
  handleEditInternalComment() {
    const _self = this;
    this.das.InternalComment(this.dealer.Header['DealerID'], this.dealer.Header['DealerUPT'], this.dealer.Header['DealerCommentInternal'])
      .subscribe(ret => {
        Object.assign(_self.dealer.Header, ret.Data);
      });
  }
  reloadAudits() {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerAuditR_List', {DealerID: this.Data.DealerID, fts: this.searchValue == null ? '' : this.searchValue});
    const mi = this.auditlistconfig.GetMetaInfo();
    mi.dataSort = {'AuditDate': 'desc'};
    _self.auditlistconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.dealer.Audits = ret.data;
        _self.auditlistconfig.paging = ret.paging;
        _self.auditlistconfig.isLoading = false;
      }
    });
  }
  reloadLocations() {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerLocationR_List', {DealerID: _self.Data.DealerID, fts: _self.searchValueLocations == null ? '' : this.searchValueLocations});
    const mi = this.locationsListconfig.GetMetaInfo();
    mi.dataSort = {'LocationName': 'asc'};
    _self.locationsListconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.dealer.Locations = ret.data;
        _self.locationsListconfig.paging = ret.paging;
        _self.locationsListconfig.isLoading = false;
      }
    });
  }
  loadStock() {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerInventoryR_List', {DealerID: this.Data.DealerID, fts: this.stockSearchValue == null ? '' : this.stockSearchValue});
    const mi = this.currentStockListconfig.GetMetaInfo();
    _self.currentStockListconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.dealer.CurrentStock = ret.data.CurrentStock;
        _self.currentStockListconfig.paging = ret.paging.CurrentStock;
        _self.currentStockListconfig.isLoading = false;
      }
    });
  }
  initialLoad () {
    const _self = this;
    _self.isLoading = true;
    const url = _self.excRest.computeUrl('DealerR_Summary', {DealerID: this.Data.DealerID});
    const mi = this.auditlistconfig.GetMetaInfo();
    mi.dataSort = {AuditPlanMonth: 'desc'};
    _self.auditlistconfig.isLoading = true;
    _self.hierarchyListconfig.isLoading = true;
    _self.currentStockListconfig.isLoading = true;
    mi.dataSort = {'AuditDate': 'desc'};
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.isLoading = false;
        _self.dealer = ret.data;
        _self.dealer.Defaults = {};
        for (const df of ret.data.Defaults) {
          _self.dealer.Defaults[df.DefaultField] = [];
          for (const v of df.Items) {
            _self.dealer.Defaults[df.DefaultField].push(v.Value);
          }
        }
        _self.auditlistconfig.paging = ret.paging.Audits;
        _self.hierarchyListconfig.paging = ret.paging.Hierarchy;
        _self.currentStockListconfig.paging = ret.paging.CurrentStock;
        _self.currentStockListconfig.isLoading = false;
        _self.auditlistconfig.isLoading = false;
        _self.hierarchyListconfig.isLoading = false;
      }
    });
  }

  pickedCheck() {
    const preselected = {mode: 'STOCK', items: []};
    for (const x of this.selectedStock) {
      preselected.items.push(x['InventoryVIN']);
    }
    const _self = this;
    this.aas.Create(this.dealer.Header, [], preselected).subscribe(ret => {
      _self.reloadAudits();
    });
  }

  openLocationDialog(Dealer, data: any) {
    const _self = this;
    let loc = {};
    if (data === null ) {
      loc = null;
    } else {
      Object.assign(loc, data);
    }
    ExcCoreModule.showModal(ModalNewLocationComponent, null, 'm',
      {Dealer: Dealer, Data: loc}, false, null).subscribe(ret => {
      if (ret.proceed === true) {
        if (data === null) {
          const url = _self.excRest.computeUrl('DealerLocationC', {DealerID: Dealer.DealerID});
          _self.excRest.post(url, {
            LocationName: ret.location.LocationName,
            LocationStreet: ret.location.LocationStreet,
            LocationZip: ret.location.LocationZip,
            LocationCity: ret.location.LocationCity,
            LocationCountry: ret.location.LocationCountry,
            LocationIsApproved: ret.location.LocationIsApproved, // _self.generateBitValue(ret.location.LocationIsApproved),
            LocationIsBusiness: ret.location.LocationIsBusiness // _self.generateBitValue(ret.location.LocationIsBusiness)
          }, {}).subscribe(obj => {
            if (obj) {
              _self.reloadLocations();
            }
          });
        } else {
          const url = _self.excRest.computeUrl('DealerLocationU', {DealerID: Dealer.DealerID});
          _self.excRest.put(url, {
            LocationID: ret.location.LocationID,
            LocationName: ret.location.LocationName,
            LocationStreet: ret.location.LocationStreet,
            LocationZip: ret.location.LocationZip,
            LocationCity: ret.location.LocationCity,
            LocationCountry: ret.location.LocationCountry,
            LocationIsApproved: ret.location.LocationIsApproved, // _self.generateBitValue(ret.location.LocationIsApproved),
            LocationIsBusiness: ret.location.LocationIsBusiness // _self.generateBitValue(ret.location.LocationIsBusiness)
          }, {}, false).subscribe(obj => {
            if (obj) {
              Object.assign(data, obj.data[0]);
            }
          });
        }
      }
    });
  }

  deleteLocations(selectedItems) {
    const _self = this;
    const requests = [];
    selectedItems.forEach(item => {
      requests.push(_self.excRest.delete(_self.excRest.computeUrl('DealerLocationD' , {DealerID: _self.dealer.Header['DealerID'],  LocationID: item.LocationID }),
        {
          DealerID: item.DealerID,
          LocationID: item.LocationID
        }, {}, false).subscribe(response => {
        _self.initialLoad();
      }));
    });
  }

  openGeofence() {
    const _self = this;
    new ExcTab(_self.dealer.Header['DealerName'], GeofenceComponent, {Header: _self.dealer.Header, Locations: _self.dealer.Locations}, _self.dealer.Header['DealerID'], {
      Unique: true, ReloadParent: function () {
      }
    }, true).Open();
  }
  exportAuditList() {
    const _self = this;
    if (_self.dealer.Audits.length > 0 ) {
      const url = this.excRest.computeUrl('DealerAuditR_export', {DealerID:  _self.dealer.Header['DealerID'], cult: _self.translateService.currentLang});
      _self.excRest.sget(url, ExcCoreModule.Guid.NewGuid(),
        {}) .subscribe(response => {
      });
    }
  }
  reloadHierarchy() {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerHierarchyR_List', {DealerID: _self.Data.DealerID, fts: _self.searchValue == null ? '' : _self.searchValue});
    _self.hierarchyListconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: this.hierarchyListconfig.GetMetaInfo()}).subscribe(ret => {
      if (ret) {
        _self.dealer.Hierarchy = ret.data;
        _self.hierarchyListconfig.paging = ret.paging;
        _self.hierarchyListconfig.isLoading = false;
      }
    });
  }
}
